import { State } from 'utils/constants/location';

/*
 * Project stage categories keyed by state (TX, FL).
 * Combines all regions within each state.
 */
export const projectStageCategoriesByState: Record<
  string,
  Record<string, Record<string, string>>
> = {
  [State.TX]: {
    'accessibility-compliance': {
      'Inspection Complete': 'In Progress',
      'Project Closed': 'Completed',
      'Project Registered': 'New',
      'Review Complete': 'In Progress',
    },
    'building-permit': {
      aborted: 'Cancelled',
      active: 'Active',
      'Additional Info Required': 'In Progress',
      'Addressing Review - Approved': 'In Progress',
      'Addressing Review - Corrections Required': 'In Progress',
      'Addressing Review - Not Required': 'In Progress',
      'Application About to Expire': 'In Progress',
      'Application Cancelled': 'Cancelled',
      'Application Denied': 'Cancelled',
      'application received': 'New',
      'Application Submittal - Awaiting Client Reply': 'In Progress',
      'Application Submittal - Correction Submitted': 'In Progress',
      'Application Submittal - Expired': 'Cancelled',
      'Application Submittal - Incomplete Submittal': 'Cancelled',
      'Application Submittal - Intake': 'New',
      'Application Submittal - New': 'New',
      'Application Submittal - Revision Submitted': 'In Progress',
      'Application Submittal - Routed for Electronic Review': 'In Progress',
      'Application Submittal - Routed for Paper Review': 'In Progress',
      'Application Submittal - Void': 'Cancelled',
      'Application Submittal - Withdrawn': 'Cancelled',
      applied: 'New',
      approved: 'Active',
      'Building Plan Review - Approved': 'In Progress',
      'Building Plan Review - Approved Revision': 'In Progress',
      'Building Plan Review - Corrections Required': 'In Progress',
      'Building Plan Review - Not Required': 'In Progress',
      'Building Plan Review - Void': 'Cancelled',
      cancelled: 'Cancelled',
      'cancelled - contractor required': 'Cancelled',
      'cancelled - new permit required': 'Cancelled',
      closed: 'Completed',
      'Closed - C of O': 'Completed',
      'Closed - Close': 'Completed',
      'closed - complete': 'Completed',
      'Closed - Denied': 'Cancelled',
      'closed - withdrawn': 'Cancelled',
      complete: 'Completed',
      Completed: 'Completed',
      'Confirm Application Complete - Completed': 'In Progress',
      'Confirm Application Complete - Passed': 'In Progress',
      'DDRB Review - Approved': 'In Progress',
      'DDRB Review - Corrections Required': 'In Progress',
      'DDRB Review - Not Required': 'In Progress',
      denied: 'Cancelled',
      'Design District Review - Approved': 'In Progress',
      'Design District Review - Corrections Required': 'In Progress',
      'Design District Review - Not Required': 'In Progress',
      'Document Received': 'In Progress',
      'Document Review - DSD - Additional Information Received': 'In Progress',
      'Document Review - DSD - Additional Information Required': 'In Progress',
      'Document Review - DSD - Closed': 'In Progress',
      'Document Review - DSD - Under Review': 'In Progress',
      'Document Review - DSD - Withdrawn': 'In Progress',
      'Document Review - Fire - Additional Information Received': 'In Progress',
      'Document Review - Fire - Closed': 'In Progress',
      'Document Review - Fire - Under Review': 'In Progress',
      'Document Review - Flood - Additional Information Received': 'In Progress',
      'Document Review - Flood - Additional Information Required': 'In Progress',
      'Document Review - Flood - Closed': 'In Progress',
      'Document Review - Flood - Under Review': 'In Progress',
      'Document Review - Inspection - Additional Information Received': 'In Progress',
      'Document Review - Inspection - Additional Information Required': 'In Progress',
      'Document Review - Inspection - Closed': 'In Progress',
      'Document Review - Inspection - Under Review': 'In Progress',
      'Document Review - Inspection - Withdrawn': 'In Progress',
      'Electrical Permit - Passed': 'In Progress',
      'Electrical Plan Review - Approved': 'In Progress',
      'Electrical Plan Review - Approved Revision': 'In Progress',
      'Electrical Plan Review - Corrections Required': 'In Progress',
      'Electrical Plan Review - Not Required': 'In Progress',
      'Electrical Plan Review - Void': 'Cancelled',
      'Environmental Review - Approved': 'In Progress',
      'Environmental Review - Not Required': 'In Progress',
      Expired: 'Cancelled',
      'Fees Due - Fees Due': 'In Progress',
      'Fees Due - Paid': 'In Progress',
      'Fees Due - Withdrawn': 'In Progress',
      final: 'Completed',
      'Fire Review - Approved': 'In Progress',
      'Fire Review - Corrections Required': 'In Progress',
      'Fire Review - FIRE ADDRESSING - Approved': 'In Progress',
      'Fire Review - Not Required': 'In Progress',
      'Gas Well Review - Approved': 'In Progress',
      'Gas Well Review - Corrections Required': 'In Progress',
      'Gas Well Review - Not Required': 'In Progress',
      'GC and/or MEPs Needed - Passed': 'In Progress',
      'Health Review - Approved': 'In Progress',
      'Health Review - Corrections Required': 'In Progress',
      'Health Review - Not Required': 'In Progress',
      'Historical Review - Approved': 'In Progress',
      'Historical Review - Corrections Required': 'In Progress',
      'Historical Review - Not Required': 'In Progress',
      'In Review': 'In Progress',
      'inactive pending revision': 'Hold',
      'Inpsection Phase': 'Active',
      'Inspection Phase': 'Active',
      'Inspections - Finaled': 'Completed',
      'Inspections - Revision Submitted': 'In Progress',
      'Inspections - Void': 'Cancelled',
      'Inspections - Withdrawn': 'Cancelled',
      'IPRC - Approved': 'In Progress',
      'IPRC - Corrections Required': 'In Progress',
      'IPRC - Not Required': 'In Progress',
      'Issuance - Active': 'Active',
      'Issuance - Partial Approval': 'In Progress',
      'Issuance - Pending Issuance': 'In Progress',
      'Issue Permit - Issued': 'Active',
      'Issue Permit - Issued Revision': 'In Progress',
      'Issue Permit - Passed': 'Active',
      'Issue Permit - Void': 'Cancelled',
      'Issue Permit - Withdrawn': 'Cancelled',
      issued: 'Active',
      'Lake Arlington Approval - Not Required': 'In Progress',
      'Lake Worth Lease Approval - Not Required': 'In Progress',
      'Mechanical Permit - Passed': 'In Progress',
      'Mechanical Plan Review - Approved': 'In Progress',
      'Mechanical Plan Review - Approved Revision': 'In Progress',
      'Mechanical Plan Review - Corrections Required': 'In Progress',
      'Mechanical Plan Review - Not Required': 'In Progress',
      'Mechanical Plan Review - Void': 'Cancelled',
      New: 'New',
      'New Application': 'New',
      'new permit required': 'Cancelled',
      'NEZ Certification Review - Awaiting NEZ Certification': 'In Progress',
      'NEZ Certification Review - Certified': 'In Progress',
      'NEZ Certification Review - Corrections Required': 'In Progress',
      'NEZ Certification Review - Denied': 'Cancelled',
      'NEZ Certification Review - Non-Qualify': 'In Progress',
      'NEZ Certification Review - Not Required': 'In Progress',
      'NEZ Certification Review - Opt-Out': 'In Progress',
      'NEZ Certification Review - Void': 'Cancelled',
      'NEZ Design Guidelines Review - Approved': 'In Progress',
      'NEZ Design Guidelines Review - Corrections Required': 'In Progress',
      'NEZ Design Guidelines Review - Non-Qualify': 'In Progress',
      'NEZ Design Guidelines Review - Not Required': 'In Progress',
      'NEZ Design Guidelines Review - Opt-Out': 'In Progress',
      'NEZ Strategic Guidelines - Approved': 'In Progress',
      'NEZ Strategic Guidelines - Corrections Required': 'In Progress',
      'NEZ Strategic Guidelines - Non-Qualify': 'In Progress',
      'NEZ Strategic Guidelines - Not Required': 'In Progress',
      'NEZ Strategic Guidelines - Opt-Out': 'In Progress',
      'NEZ Strategic Guidelines Review - Non-Qualify': 'In Progress',
      'NEZ Strategic Guidelines Review - Not Required': 'In Progress',
      'NEZ Strategic Guidelines Review - Opt-Out': 'In Progress',
      'Noise Contour Review - Not Required': 'In Progress',
      'not started': 'In Progress',
      'notice sent': 'In Progress',
      'on hold': 'Hold',
      'PARD Review - Approved': 'In Progress',
      'PARD Review - Corrections Required': 'In Progress',
      'PARD Review - Not Required': 'In Progress',
      'Parkway Review - Approved': 'In Progress',
      'Parkway Review - Corrections Required': 'In Progress',
      'Parkway Review - Not Required': 'In Progress',
      'partial approval': 'In Progress',
      'Payment Due': 'In Progress',
      pending: 'In Progress',
      'Pending CO': 'In Progress',
      'pending permit': 'In Progress',
      'Permit About to Expire': 'In Progress',
      'Permit Application Approved': 'In Progress',
      'Permit Closure - Closed': 'Completed',
      'Permit Closure - COO Issuance Review Required': 'Active',
      'Permit Closure - COO Issued': 'Completed',
      'Permit Closure - LOC Issued': 'Completed',
      'Permit Closure - Withdrawn': 'Cancelled',
      'permit expired': 'Cancelled',
      'Permit Fee Waiver Review - Eligible': 'In Progress',
      'Permit Fee Waiver Review - Not Applicable': 'In Progress',
      'Permit Fee Waiver Review - Not Eligible': 'In Progress',
      'Permit Fee Waiver Review - Withdrawn': 'Cancelled',
      'Permit Fees Due - Fees Due': 'In Progress',
      'Permit Fees Due - No Fees': 'In Progress',
      'Permit Fees Due - Paid': 'In Progress',
      'Permit Fees Due - Withdrawn': 'Cancelled',
      'permit issued': 'Active',
      'Permit Pending': 'In Progress',
      'permit revoked': 'Cancelled',
      'Permit Suspended': 'Cancelled',
      'Plan Distribution - Awaiting Client Reply': 'In Progress',
      'Plan Distribution - Correction Submitted': 'In Progress',
      'Plan Distribution - Revision Submitted': 'In Progress',
      'Plan Distribution - Routed for Electronic Review': 'In Progress',
      'Plan Review': 'In Progress',
      'Plans Coordination - Approved': 'In Progress',
      'Plans Coordination - Approved Revision': 'In Progress',
      'Plans Coordination - Corrections Required': 'In Progress',
      'Plans waiting on customer': 'In Progress',
      'Plumbing Permit - Passed': 'In Progress',
      'Plumbing Plan Review - Approved': 'In Progress',
      'Plumbing Plan Review - Approved Revision': 'In Progress',
      'Plumbing Plan Review - Corrections Required': 'In Progress',
      'Plumbing Plan Review - Not Required': 'In Progress',
      'Plumbing Plan Review - Void': 'Cancelled',
      'Plumbing Rough Inspection - Passed': 'In Progress',
      'Project Close Out - Passed': 'Completed',
      're review': 'In Progress',
      'ready to issue': 'In Progress',
      'Reinstatement - Reinstatement': 'Active',
      rejected: 'Cancelled',
      'Release to CPS - CPS - Permanent Review Required': 'In Progress',
      'Release to CPS - Release to CPS - GAS': 'In Progress',
      'Release to CPS - Release to CPS - GAS - Review': 'In Progress',
      'Release to CPS - Release to CPS - No Action': 'In Progress',
      'Release to CPS - Release to CPS - Permanent': 'In Progress',
      'Release to CPS - Release to CPS - TML': 'In Progress',
      'Release to CPS - Release to CPS - TOPS': 'In Progress',
      'Release to CPS - Release to CPS - TOPS - Review': 'In Progress',
      'Release to CPS - Release to CPS - WWCPS': 'In Progress',
      'Release to CPS - Withdrawn': 'In Progress',
      'Review - Not Passed': 'Cancelled',
      'Review - Passed': 'In Progress',
      'Review - Started': 'In Progress',
      'Revisions Required': 'In Progress',
      Revoked: 'Cancelled',
      'Revoked - Revoked': 'Cancelled',
      'Submitted - Online': 'New',
      Suspended: 'Cancelled',
      'Temp COO Issuance - Completed': 'In Progress',
      'Temp COO Issuance - Temp COO - FFE': 'In Progress',
      'Temp COO Issuance - Temp COO - Full': 'In Progress',
      'Temp COO Issuance - Temp COO Expired': 'In Progress',
      'TPW CFRA Review - Approved': 'In Progress',
      'TPW CFRA Review - Corrections Required': 'In Progress',
      'TPW CFRA Review - Not Required': 'In Progress',
      'TPW Engineering Review - Approved': 'In Progress',
      'TPW Engineering Review - Corrections Required': 'In Progress',
      'TPW Engineering Review - Drive Thru-Stacking Review - Approved': 'In Progress',
      'TPW Engineering Review - Drive Thru-Stacking Review - Corrections Required':
        'In Progress',
      'TPW Engineering Review - Drive Thru-Stacking Review - Denied': 'Cancelled',
      'TPW Engineering Review - Not Required': 'In Progress',
      'TPW Engineering Review - Plan Review - Corrections Required': 'In Progress',
      'TPW Engineering Review - PLAN- REVIEW - Approved': 'In Progress',
      'TPW Engineering Review - Review of CFA before Building CO Public Lighting/Paving along Green Ave & W Berry Street - Approved':
        'In Progress',
      'TPW Engineering Review - Review of CFA before Building CO Public Lighting/Paving along Green Ave & W Berry Street - Corrections Required':
        'In Progress',
      'TPW Engineering Review - TPW Engineering - Approved': 'In Progress',
      'TPW Engineering Review - TPW Engineering - Corrections Required': 'In Progress',
      'TPW Engineering Review - TPW Engineering Review - Approved': 'In Progress',
      'TPW Engineering Review - TPW Engineering Review - Corrections Required':
        'In Progress',
      'TPW Floodplain Review - Approved': 'In Progress',
      'TPW Floodplain Review - Corrections Required': 'In Progress',
      'TPW Floodplain Review - Not Required': 'In Progress',
      'TPW Storm Water Review - Approved': 'In Progress',
      'TPW Storm Water Review - Corrections Required': 'In Progress',
      'TPW Storm Water Review - Encroachment agreement must be executed, PN25-00115 before issue of CO - Approved':
        'In Progress',
      'TPW Storm Water Review - Not Required': 'In Progress',
      'Transportation Impact Review - Approved': 'In Progress',
      'Transportation Impact Review - Corrections Required': 'In Progress',
      'Transportation Impact Review - Not Required': 'In Progress',
      'Urban Forestry Review - Approved': 'In Progress',
      'Urban Forestry Review - Corrections Required': 'In Progress',
      'Urban Forestry Review - Not Required': 'In Progress',
      void: 'Cancelled',
      'Water Backflow Review - Approved': 'In Progress',
      'Water Backflow Review - Corrections Required': 'In Progress',
      'Water Backflow Review - Not Required': 'In Progress',
      'Water Development Review - Approved': 'In Progress',
      'Water Development Review - Corrections Required': 'In Progress',
      'Water Development Review - Not Required': 'In Progress',
      'Water Development Review - Void': 'Cancelled',
      'Water Development Storm Water Review - Approved': 'In Progress',
      'Water Development Storm Water Review - Corrections Required': 'In Progress',
      'Water Development Storm Water Review - Not Required': 'In Progress',
      'Water Grease Trap Review - Approved': 'In Progress',
      'Water Grease Trap Review - Corrections Required': 'In Progress',
      'Water Grease Trap Review - Not Required': 'In Progress',
      withdrawn: 'Cancelled',
      'Withdrawn - Withdrawn': 'Cancelled',
      'Work Completed': 'Completed',
      'Zoning Review - Approved': 'In Progress',
      'Zoning Review - Approved Revision': 'In Progress',
      'Zoning Review - Corrections Required': 'In Progress',
      'Zoning Review - Not Required': 'In Progress',
      'Zoning Review - Void': 'Cancelled',
    },
    'business-licence': {
      cancelled: 'Cancelled',
      Expired: 'Cancelled',
      Inactive: 'Cancelled',
      issued: 'Completed',
      pending: 'In Progress',
    },
    'electrical-permit': {
      aborted: 'Cancelled',
      active: 'Active',
      'Application Cancelled': 'Cancelled',
      'Application Denied': 'In Progress',
      'application incomplete': 'Cancelled',
      'application received': 'New',
      'Application Submittal - Accepted': 'New',
      'Application Submittal - Correction Submitted': 'In Progress',
      'Application Submittal - Incomplete Submittal': 'Cancelled',
      'Application Submittal - Void': 'Cancelled',
      approved: 'Active',
      cancelled: 'Cancelled',
      'cancelled - contractor required': 'Cancelled',
      'cancelled - new permit required': 'Cancelled',
      closed: 'Completed',
      'Closed - Close': 'Completed',
      complete: 'Completed',
      Completed: 'Completed',
      'Document Review - Additional Information Received': 'In Progress',
      'Document Review - Additional Information Required': 'In Progress',
      'Document Review - Approved': 'In Progress',
      'Document Review - Reviewed No Action': 'In Progress',
      'Document Review - Under Review': 'In Progress',
      'Document Review - Withdrawn': 'In Progress',
      Expired: 'Cancelled',
      'Fees Due - Fees Due': 'In Progress',
      'Fees Due - No Fees': 'In Progress',
      'Fees Due - Paid': 'In Progress',
      'Fees Due - Withdrawn': 'In Progress',
      final: 'Completed',
      'inactive contractor': 'Cancelled',
      'inactive pending revision': 'Hold',
      'Inspections - Finaled': 'Completed',
      'Issuance - Active': 'Active',
      'Issue Permit - Issued': 'Active',
      issued: 'Active',
      New: 'New',
      'New Application': 'New',
      'new permit required': 'Cancelled',
      'New Web Application': 'New',
      'on hold': 'Hold',
      pending: 'In Progress',
      'pending permit': 'In Progress',
      'Permit Application Approved': 'Active',
      'Permit Closure - Closed': 'Cancelled',
      'permit expired': 'Cancelled',
      'permit issued': 'Active',
      'Permit Pending': 'In Progress',
      'permit revoked': 'Cancelled',
      'Plans waiting on customer': 'In Progress',
      queue: 'In Progress',
      're review': 'In Progress',
      'ready to issue': 'Active',
      'Reinstatement - Reinstatement': 'Active',
      'Release to CPS - Release to CPS - DG': 'In Progress',
      'Release to CPS - Release to CPS - GAS': 'In Progress',
      'Release to CPS - Release to CPS - General': 'In Progress',
      'Release to CPS - Release to CPS - TML': 'In Progress',
      'Release to CPS - Release to CPS - TOPS': 'In Progress',
      'Release to CPS - Release to CPS - WWCPS': 'In Progress',
      'Release to CPS - Withdrawn': 'In Progress',
      Revoked: 'Cancelled',
      Suspended: 'Cancelled',
      'Temporary Utility Review - Approved': 'In Progress',
      'under ae review': 'In Progress',
      void: 'Cancelled',
      withdrawn: 'Cancelled',
      'Withdrawn - Withdrawn': 'Cancelled',
      'Work Completed': 'Completed',
    },
    entitlement: {
      applied: 'In Progress',
      approved: 'Active',
      cancelled: 'Cancelled',
      closed: 'Completed',
      'closed - complete': 'Completed',
      'closed - withdrawn': 'Cancelled',
      Completed: 'Completed',
      denied: 'Cancelled',
      issued: 'Active',
      'on hold': 'Hold',
      pending: 'In Progress',
      withdrawn: 'Cancelled',
    },
    'land-title-change': {
      Completed: 'Completed',
    },
    'mechanical-permit': {
      'Application Cancelled': 'Cancelled',
      'Application Denied': 'Cancelled',
      'Application Submittal - Accepted': 'In Progress',
      'Application Submittal - Incomplete Submittal': 'Cancelled',
      'Application Submittal - Void': 'Cancelled',
      'Closed - Close': 'Completed',
      'Inspections - Finaled': 'Completed',
      'Issue Permit - Issued': 'Active',
      'New Application': 'New',
      'New Web Application': 'New',
      'Permit Application Approved': 'Active',
      'permit expired': 'Cancelled',
      'permit issued': 'Active',
      'Permit Pending': 'In Progress',
      'permit revoked': 'Cancelled',
      'Work Completed': 'Completed',
    },
    plat: {
      'action form completed': 'In Progress',
      'application submitted': 'New',
      'awaiting assignment': 'In Progress',
      'awaiting completeness': 'In Progress',
      'being reviewed': 'In Progress',
      'check-in complete': 'In Progress',
      'updating action form': 'In Progress',
    },
    'plumbing-permit': {
      'Application Cancelled': 'Cancelled',
      'Application Denied': 'Cancelled',
      'Application Submittal - Accepted': 'In Progress',
      'Application Submittal - Incomplete Submittal': 'Cancelled',
      'Application Submittal - Void': 'Cancelled',
      'Closed - Close': 'Completed',
      'Inspections - Finaled': 'Completed',
      'Issue Permit - Issued': 'Active',
      'New Application': 'New',
      'New Web Application': 'New',
      'Permit Application Approved': 'Active',
      'permit expired': 'Cancelled',
      'permit issued': 'Active',
      'Permit Pending': 'In Progress',
      'permit revoked': 'Cancelled',
      'Work Completed': 'Completed',
    },
    rezoning: {
      aborted: 'Cancelled',
      active: 'Completed',
      'Additional Info Required': 'In Progress',
      'Agenda Coversheet - Draft Coversheet Completed': 'In Progress',
      'Agenda Coversheet - FInal Coversheet Approved': 'In Progress',
      'Agenda Coversheet - Postponement': 'In Progress',
      'Agenda Coversheet - Under Review': 'In Progress',
      'Agenda Coversheet - Withdrawn': 'In Progress',
      'Application Intake - Received': 'New',
      'Application Intake - Received Online': 'New',
      'application received': 'New',
      'Application Submittal - Accepted': 'New',
      approved: 'Completed',
      'approved and released': 'Completed',
      'Automatically Renewed': 'Completed',
      'awaiting update': 'In Progress',
      cancelled: 'Cancelled',
      'case assigned': 'In Progress',
      'Case Manager Review - Additional Information Received': 'In Progress',
      'Case Manager Review - Additional Information Required': 'In Progress',
      'Case Manager Review - Completed': 'In Progress',
      'Case Manager Review - Postponement': 'In Progress',
      'Case Manager Review - Under Review': 'In Progress',
      'Case Manager Review - Withdrawn': 'In Progress',
      'cc accepted': 'In Progress',
      'City Council Agenda Coversheet - Draft Coversheet Completed': 'In Progress',
      'City Council Agenda Coversheet - Final Coversheet Approved': 'In Progress',
      'City Council Agenda Coversheet - Postponement': 'In Progress',
      'City Council Agenda Coversheet - Under Review': 'In Progress',
      'City Council Agenda Coversheet - Withdrawn': 'In Progress',
      'City Council Legal Ad Posted - Completed': 'In Progress',
      'City Council Legal Ad Posted - Postponement': 'In Progress',
      'City Council Legal Ad Posted - Under Review': 'In Progress',
      'City Council Legal Ad Posted - Withdrawn': 'In Progress',
      'City Council Meeting - Approved': 'In Progress',
      'City Council Meeting - Approved with Conditions': 'In Progress',
      'City Council Meeting - Continuance': 'In Progress',
      'City Council Meeting - Denied': 'Cancelled',
      'City Council Meeting - Postponement': 'In Progress',
      'City Council Meeting - Under Review': 'In Progress',
      'City Council Meeting - Withdrawn': 'In Progress',
      'City Council Notices Mailed to Property Owners - Completed': 'In Progress',
      'City Council Notices Mailed to Property Owners - Postponement': 'Hold',
      'City Council Notices Mailed to Property Owners - Under Review': 'In Progress',
      'City Council Notices Mailed to Property Owners - Withdrawn': 'In Progress',
      'City Council Staff Report - Draft Staff Report Completed': 'In Progress',
      'City Council Staff Report - Final Staff Report Approved': 'In Progress',
      'City Council Staff Report - Postponement': 'In Progress',
      'City Council Staff Report - Under Review': 'In Progress',
      'City Council Staff Report - Withdrawn': 'In Progress',
      closed: 'Completed',
      'Closed - Denied': 'Cancelled',
      'closed - withdrawn': 'Cancelled',
      'Closure - Closed': 'Completed',
      'Closure - Withdrawn': 'Cancelled',
      Completed: 'Completed',
      'Completeness Review - Additional Information Received': 'New',
      'Completeness Review - Additional Information Required': 'New',
      'Completeness Review - Completed': 'New',
      'Completeness Review - Under Review': 'New',
      'Completeness Review - Withdrawn': 'Cancelled',
      'Confirm Application Complete - Passed': 'In Progress',
      'Creation and Publication of Ordinances - Completed': 'In Progress',
      'Creation and Publication of Ordinances - Postponement': 'In Progress',
      'Creation and Publication of Ordinances - Under Review': 'In Progress',
      denied: 'Cancelled',
      'Document Received': 'In Progress',
      'Draft Ordinance - Draft Ordinance Completed': 'In Progress',
      'Draft Ordinance - Postponement': 'In Progress',
      'Draft Ordinance - Under Review': 'In Progress',
      'Draft Ordinance - Withdrawn': 'Cancelled',
      'Draft Ordinance Review - Draft Ordinance Submitted': 'In Progress',
      'Draft Ordinance Review - Ordinance Revisions Required': 'In Progress',
      'Draft Ordinance Review - Postponement': 'In Progress',
      'Draft Ordinance Review - Under Review': 'In Progress',
      'Draft Ordinance Review - Withdrawn': 'Cancelled',
      'Draft Resolution - Draft Resolution Completed': 'In Progress',
      'Draft Resolution - Final Resolution Approved': 'In Progress',
      'Draft Resolution - Postponement': 'In Progress',
      'Draft Resolution - Under Review': 'In Progress',
      'Draft Resolution - Withdrawn': 'Cancelled',
      Expired: 'Cancelled',
      'Fees Due - No Fees': 'In Progress',
      'GIS Review - Completed': 'In Progress',
      'GIS Review - Under Review': 'In Progress',
      'GIS Review - Withdrawn': 'Cancelled',
      'hearing scheduled': 'In Progress',
      'Held under Advisement': 'In Progress',
      'in progress': 'In Progress',
      'In Review': 'In Progress',
      'Invoice Public Notification Fees - Passed': 'In Progress',
      issued: 'Active',
      'Legal Ad - Completed': 'In Progress',
      'Legal Ad - Postponement': 'In Progress',
      'Legal Ad - Under Review': 'In Progress',
      'Legal Ad Posted - Completed': 'In Progress',
      'Legal Ad Posted - Postponement': 'In Progress',
      'Legal Ad Posted - Under Review': 'In Progress',
      'Manager Review - Additional Information Received': 'In Progress',
      'Manager Review - Additional Information Required': 'In Progress',
      'Manager Review - Map Request': 'In Progress',
      'Manager Review - Recharge Zone': 'In Progress',
      'Manager Review - Reviewed and Assigned Case': 'In Progress',
      'Manager Review - Under Review': 'In Progress',
      'Manager Review - Withdrawn': 'In Progress',
      New: 'New',
      'notice requested': 'In Progress',
      'notice sent': 'In Progress',
      'notice/hearing determination': 'In Progress',
      'Notices Mailed to Property Owners - Completed': 'In Progress',
      'Notices Mailed to Property Owners - Postponement': 'In Progress',
      'Notices Mailed to Property Owners - Under Review': 'In Progress',
      'Notices Mailed to Property Owners - Withdrawn': 'In Progress',
      'Ordinances Finalized - Completed': 'In Progress',
      'Ordinances Finalized - Postponement': 'In Progress',
      'Ordinances Finalized - Under Review': 'In Progress',
      'partial approval': 'In Progress',
      'Payment Due': 'In Progress',
      'Payment Received': 'In Progress',
      pending: 'In Progress',
      'Pending CC': 'In Progress',
      'Pending CPC': 'In Progress',
      'pending-pre-open': 'In Progress',
      'Plan Review': 'In Progress',
      'Planning and Zoning and Council Packet Prepared - Passed': 'In Progress',
      'Planning Commission Meeting - Continuance': 'In Progress',
      'Planning Commission Meeting - Postponement': 'In Progress',
      'Planning Commission Meeting - Recommend Approval': 'In Progress',
      'Planning Commission Meeting - Recommend Denial': 'In Progress',
      'Planning Commission Meeting - Under Review': 'In Progress',
      'Planning Commission Meeting - Withdrawn': 'In Progress',
      postponed: 'Cancelled',
      'Preliminary Meeting - Additional Information Received': 'In Progress',
      'Preliminary Meeting - Additional Information Required': 'In Progress',
      'Preliminary Meeting - Postponement': 'In Progress',
      'Preliminary Meeting - Proceed to Notice': 'In Progress',
      'Preliminary Meeting - Under Review': 'In Progress',
      'Preliminary Meeting - Withdrawn': 'In Progress',
      'Public Notice Prepared & Sent - Passed': 'In Progress',
      'reading approved': 'In Progress',
      'recommended for approval': 'In Progress',
      'Returned to Applicant': 'Cancelled',
      'Review - In Progress': 'In Progress',
      'Review - Passed': 'Completed',
      'SAWS Review - Under Review': 'In Progress',
      'SAWS Review - Withdrawn': 'Cancelled',
      'scheduled for council hearing': 'In Progress',
      'scheduled for hearing': 'In Progress',
      'Staff Recommendation Determined - Passed': 'In Progress',
      'Staff Report - Draft Staff Report Completed': 'In Progress',
      'Staff Report - Final Staff Report Approved': 'In Progress',
      'Staff Report - Postponement': 'In Progress',
      'Staff Report - Under Review': 'In Progress',
      'Staff Report - Withdrawn': 'In Progress',
      'Submitted - Online': 'New',
      'Technical Review - Addressing - Address Assigned': 'In Progress',
      'Technical Review - Addressing - Under Review': 'In Progress',
      'Verify Addresses for Property Owners - Passed': 'In Progress',
      void: 'Cancelled',
      'Waiting on Ordinance': 'In Progress',
      withdrawn: 'Cancelled',
      'Zoning Commission Meeting - Continuance': 'In Progress',
      'Zoning Commission Meeting - Postponement': 'In Progress',
      'Zoning Commission Meeting - Recommend Approval': 'In Progress',
      'Zoning Commission Meeting - Recommend Approval with Conditions': 'In Progress',
      'Zoning Commission Meeting - Recommend Denial': 'In Progress',
      'Zoning Commission Meeting - Under Review': 'In Progress',
      'Zoning Commission Meeting - Withdrawn': 'In Progress',
    },
    'site-plan': {
      aborted: 'Cancelled',
      active: 'Active',
      'Additional Info Required': 'In Progress',
      'Addressing Review - Approved': 'In Progress',
      'admin hold': 'Hold',
      'application incomplete': 'Cancelled',
      'Application Intake - Received': 'New',
      'Application Intake - Received Online': 'New',
      'application received': 'New',
      'Application Submittal - Accepted': 'New',
      'Application Submittal - Correction Submitted': 'In Progress',
      'Application Submittal - Incomplete Submittal': 'Cancelled',
      'Application Submittal - Non-Qualify': 'In Progress',
      'Application Submittal - Opt-Out': 'In Progress',
      'Application Submittal - Routed for Electronic Review': 'In Progress',
      'Application Submittal - Routed for Paper Review': 'In Progress',
      'Application Submittal - Routed for Review': 'In Progress',
      'Application Submittal - Void': 'Cancelled',
      'Application Submittal - Withdrawn': 'Cancelled',
      approved: 'Active',
      'approved and released': 'Completed',
      'approved for construction permit': 'Active',
      'Automatically Renewed': 'Completed',
      'awaiting update': 'In Progress',
      'awaiting update - technical review': 'In Progress',
      'Building Plan Review - Corrections Required': 'In Progress',
      cancelled: 'Cancelled',
      'cc approved': 'In Progress',
      'cc pending': 'In Progress',
      'cc pending - fees paid': 'In Progress',
      'cc rejected': 'In Progress',
      closed: 'Completed',
      'Closed - Close': 'Completed',
      'closed - complete': 'Completed',
      'Closed - Denied': 'Cancelled',
      'Closed - Non-Qualify': 'Cancelled',
      'Closed - Opt-Out': 'Cancelled',
      'closed - withdrawn': 'Cancelled',
      'Closure - Closed': 'Completed',
      'Closure - Closure': 'Completed',
      'Closure - Withdrawn': 'Cancelled',
      Completed: 'Completed',
      'Completeness Review - Additional Information Received': 'In Progress',
      'Completeness Review - Additional Information Required': 'In Progress',
      'Completeness Review - Approved': 'In Progress',
      'Completeness Review - File Validation Issues': 'In Progress',
      'Completeness Review - Under Review': 'In Progress',
      'Completeness Review - Withdrawn': 'Cancelled',
      'Completeness Review Zoning - Additional Information Received': 'In Progress',
      'Completeness Review Zoning - Additional Information Required': 'In Progress',
      'Completeness Review Zoning - Approved': 'In Progress',
      'Completeness Review Zoning - Denied': 'Cancelled',
      'Completeness Review Zoning - Under Review': 'In Progress',
      'Completeness Review Zoning - Withdrawn': 'Cancelled',
      'Confirm Application Complete - Not Passed': 'Cancelled',
      'Customer Time': 'In Progress',
      'Customer Time Express': 'In Progress',
      denied: 'Cancelled',
      'Document Received': 'In Progress',
      'Electrical Plan Review - Approved': 'In Progress',
      'Elevation Certificate - Accepted': 'In Progress',
      'Elevation Certificate - Not Required': 'In Progress',
      'Elevation Certificate - Submittal Required': 'In Progress',
      'Environmental Review - Approved': 'In Progress',
      'Environmental Review - Corrections Required': 'In Progress',
      'Environmental Review - Not Required': 'In Progress',
      Expired: 'Cancelled',
      'fee not issued': 'In Progress',
      'Fee Waiver Review - Eligible': 'In Progress',
      'Fee Waiver Review - Not Applicable': 'In Progress',
      'Fee Waiver Review - Not Eligible': 'In Progress',
      'Fee Waiver Review - Under Review': 'In Progress',
      'Fees Due': 'In Progress',
      'Fees Due - Fees Due': 'In Progress',
      'Fees Due - No Fees': 'In Progress',
      'Fees Due - Paid': 'In Progress',
      'Fire Review - Approved': 'In Progress',
      'formal intake accepted - fees due': 'In Progress',
      'formal intake accepted - fees paid': 'In Progress',
      'Gas Well Review - Approved': 'In Progress',
      'Health Review - Not Required': 'In Progress',
      'hearing scheduled': 'In Progress',
      'Held under Advisement': 'In Progress',
      'Historical Review - Approved': 'In Progress',
      'Historical Review - Corrections Required': 'In Progress',
      'Historical Review - Denied': 'Cancelled',
      'Historical Review - Not Required': 'In Progress',
      'in e-review': 'In Progress',
      'In Express Review': 'In Progress',
      'in progress': 'In Progress',
      'In Review': 'In Progress',
      Inactive: 'Cancelled',
      'Inspections - Revision Submitted': 'In Progress',
      'intake accepted': 'In Progress',
      'intake accepted - fees due': 'In Progress',
      'intake pending': 'In Progress',
      'intake rejected': 'Cancelled',
      'internet pending': 'New',
      'Issue Permit - Issued': 'Active',
      'Issue Permit - Revision Submitted': 'In Progress',
      issued: 'Active',
      'LOMR - Not Required': 'In Progress',
      'LOMR - Submittal Required': 'In Progress',
      'Mechanical Plan Review - Approved': 'In Progress',
      New: 'New',
      'NEZ Design Guidelines Review - Approved': 'In Progress',
      'NEZ Design Guidelines Review - Corrections Required': 'In Progress',
      'NEZ Design Guidelines Review - Not Required': 'In Progress',
      'NEZ Review - Approved': 'In Progress',
      'NEZ Review - Corrections Required': 'In Progress',
      'NEZ Review - Denied': 'Cancelled',
      'NEZ Review - Not Required': 'In Progress',
      'Not Approved': 'Cancelled',
      'not started': 'In Progress',
      'on hold': 'Hold',
      'PARD Review - Approved': 'In Progress',
      'PARD Review - Corrections Required': 'In Progress',
      'PARD Review - Not Required': 'In Progress',
      'Partial Permit Review - Additional Information Received': 'In Progress',
      'Partial Permit Review - Additional Information Required': 'In Progress',
      'Partial Permit Review - Addressing - Additional Information Received':
        'In Progress',
      'Partial Permit Review - Addressing - Additional Information Required':
        'In Progress',
      'Partial Permit Review - Addressing - Approved': 'In Progress',
      'Partial Permit Review - Addressing - Under Review': 'In Progress',
      'Partial Permit Review - Approved': 'In Progress',
      'Partial Permit Review - Aviation - Approved': 'In Progress',
      'Partial Permit Review - Aviation - Under Review': 'In Progress',
      'Partial Permit Review - Commercial Building - Additional Information Received':
        'In Progress',
      'Partial Permit Review - Commercial Building - Additional Information Required':
        'In Progress',
      'Partial Permit Review - Commercial Building - Approved': 'In Progress',
      'Partial Permit Review - Commercial Building - Approved with Conditions':
        'In Progress',
      'Partial Permit Review - Commercial Building - Denied': 'In Progress',
      'Partial Permit Review - Commercial Building - Reviewed No Action': 'In Progress',
      'Partial Permit Review - Commercial Building - Under Review': 'In Progress',
      'Partial Permit Review - Denied': 'In Progress',
      'Partial Permit Review - Drainage - Approved': 'In Progress',
      'Partial Permit Review - Drainage - Under Review': 'In Progress',
      'Partial Permit Review - Electric - Approved': 'In Progress',
      'Partial Permit Review - Fire - Reviewed No Action': 'In Progress',
      'Partial Permit Review - Health Environmental - Approved': 'In Progress',
      'Partial Permit Review - Health Environmental - Reviewed No Action': 'In Progress',
      'Partial Permit Review - Health Environmental - Under Review': 'In Progress',
      'Partial Permit Review - Health Food Custodian - Reviewed No Action': 'In Progress',
      'Partial Permit Review - Health Food Custodian - Under Review': 'In Progress',
      'Partial Permit Review - Irrigation - Additional Information Received':
        'In Progress',
      'Partial Permit Review - Irrigation - Additional Information Required':
        'In Progress',
      'Partial Permit Review - Irrigation - Approved': 'In Progress',
      'Partial Permit Review - Landscaping - Approved': 'In Progress',
      'Partial Permit Review - Mechanical - Approved': 'In Progress',
      'Partial Permit Review - Mechanical - Under Review': 'In Progress',
      'Partial Permit Review - Plumbing - Reviewed No Action': 'In Progress',
      'Partial Permit Review - Plumbing - Under Review': 'In Progress',
      'Partial Permit Review - Reviews in Process': 'In Progress',
      'Partial Permit Review - Sidewalk/Traffic - Additional Information Required':
        'In Progress',
      'Partial Permit Review - Sidewalk/Traffic - Approved': 'In Progress',
      'Partial Permit Review - Sidewalk/Traffic - Denied': 'In Progress',
      'Partial Permit Review - Sidewalk/Traffic - Under Review': 'In Progress',
      'Partial Permit Review - Sidewalk/Traffic - Withdrawn': 'In Progress',
      'Partial Permit Review - Traffic Impact Analysis - Additional Information Required':
        'In Progress',
      'Partial Permit Review - Traffic Impact Analysis - Approved': 'In Progress',
      'Partial Permit Review - Traffic Impact Analysis - Denied': 'In Progress',
      'Partial Permit Review - Traffic Impact Analysis - Under Review': 'In Progress',
      'Partial Permit Review - Traffic Impact Analysis - Withdrawn': 'In Progress',
      'Partial Permit Review - Tree Commercial - Additional Information Required':
        'In Progress',
      'Partial Permit Review - Tree Commercial - Approved': 'In Progress',
      'Partial Permit Review - Under Review': 'In Progress',
      'Partial Permit Review - Zoning - Denied': 'In Progress',
      'Partial Permit Review - Zoning - Under Review': 'In Progress',
      'Payment Due': 'In Progress',
      'Payment Received': 'In Progress',
      pending: 'In Progress',
      'Pending CC': 'In Progress',
      'Pending CPC': 'In Progress',
      'pending payment': 'In Progress',
      'Permit Issued - Approved': 'Active',
      'Permit Issued - Issued': 'Active',
      'Permit Issued - Pending Issuance': 'Active',
      'Permit Issued - Permit Closure': 'Completed',
      'Permit Issued - Post Permit Review Required': 'Completed',
      'Permit Issued - Withdrawn': 'Cancelled',
      'Plan Coordination - Approved': 'In Progress',
      'Plan Coordination - Corrections Required': 'In Progress',
      'Plan Coordination - Denied': 'Cancelled',
      'Plan Coordination - Opt-Out': 'In Progress',
      'Plan Distribution - Awaiting Client Reply': 'In Progress',
      'Plan Distribution - Correction Submitted': 'In Progress',
      'Plan Distribution - Revision Submitted': 'In Progress',
      'Plan Distribution - Routed for Electronic Review': 'In Progress',
      'Plan Distribution - Routed for Review': 'In Progress',
      'Plan Review': 'In Progress',
      'Plans Coordination - Approved': 'In Progress',
      'Plans Coordination - Correction Required': 'In Progress',
      'Plans Coordination - Corrections Required': 'In Progress',
      'Plans Coordination - Partial Approval': 'In Progress',
      'Plumbing Plan Review - Approved': 'In Progress',
      'Post Permit Completeness Review - Additional Information Received': 'Active',
      'Post Permit Completeness Review - Additional Information Required': 'Cancelled',
      'Post Permit Completeness Review - Denied': 'Cancelled',
      'Post Permit Completeness Review - No Reviews Required': 'Completed',
      'Post Permit Completeness Review - Reviews in Process': 'Active',
      'Post Permit Completeness Review - Under Review': 'Active',
      'Post Permit Completeness Review - Withdrawn': 'Cancelled',
      'Post Permit Review - Addressing - Additional Information Received': 'Active',
      'Post Permit Review - Addressing - Additional Information Required': 'Active',
      'Post Permit Review - Addressing - Approved': 'Active',
      'Post Permit Review - Addressing - Under Review': 'Active',
      'Post Permit Review - Aviation - Approved': 'Active',
      'Post Permit Review - Aviation - Under Review': 'Active',
      'Post Permit Review - Commercial Building - Additional Information Received':
        'Active',
      'Post Permit Review - Commercial Building - Additional Information Required':
        'Active',
      'Post Permit Review - Commercial Building - Approved': 'Active',
      'Post Permit Review - Commercial Building - Approved with Conditions': 'Active',
      'Post Permit Review - Commercial Building - Denied': 'Cancelled',
      'Post Permit Review - Commercial Building - Under Review': 'Active',
      'Post Permit Review - Commercial Building - Withdrawn': 'Cancelled',
      'Post Permit Review - Disability - Under Review': 'Active',
      'Post Permit Review - Drainage - Additional Information Received': 'Active',
      'Post Permit Review - Drainage - Additional Information Required': 'Active',
      'Post Permit Review - Drainage - Approved': 'Active',
      'Post Permit Review - Drainage - Under Review': 'Active',
      'Post Permit Review - Electric - Additional Information Received': 'Active',
      'Post Permit Review - Electric - Additional Information Required': 'Active',
      'Post Permit Review - Electric - Approved': 'Active',
      'Post Permit Review - Electric - Approved with Conditions': 'Active',
      'Post Permit Review - Electric - Under Review': 'Active',
      'Post Permit Review - Electric - Withdrawn': 'Cancelled',
      'Post Permit Review - Energy - Additional Information Received': 'Active',
      'Post Permit Review - Energy - Additional Information Required': 'Active',
      'Post Permit Review - Energy - Approved': 'Active',
      'Post Permit Review - Energy - Reviewed No Action': 'Active',
      'Post Permit Review - Energy - Under Review': 'Active',
      'Post Permit Review - Fire - Additional Information Received': 'Active',
      'Post Permit Review - Fire - Additional Information Required': 'Active',
      'Post Permit Review - Fire - Approved': 'Active',
      'Post Permit Review - Fire - Approved with Conditions': 'Active',
      'Post Permit Review - Fire - Denied': 'Cancelled',
      'Post Permit Review - Fire - Under Review': 'Active',
      'Post Permit Review - Fire - Withdrawn': 'Cancelled',
      'Post Permit Review - Fire OCL - Additional Information Received': 'Active',
      'Post Permit Review - Fire OCL - Additional Information Required': 'Active',
      'Post Permit Review - Fire OCL - Approved': 'Active',
      'Post Permit Review - Fire OCL - Under Review': 'Active',
      'Post Permit Review - Fire Smoke Control - Additional Information Received':
        'Active',
      'Post Permit Review - Fire Smoke Control - Additional Information Required':
        'Active',
      'Post Permit Review - Fire Smoke Control - Approved': 'Active',
      'Post Permit Review - Fire Smoke Control - Under Review': 'Active',
      'Post Permit Review - Flood - Additional Information Received': 'Active',
      'Post Permit Review - Flood - Additional Information Required': 'Active',
      'Post Permit Review - Flood - Approved': 'Active',
      'Post Permit Review - Flood - Under Review': 'Active',
      'Post Permit Review - Health Environmental - Approved': 'Active',
      'Post Permit Review - Health Environmental - Under Review': 'Active',
      'Post Permit Review - Health Food Custodian - Additional Information Received':
        'Active',
      'Post Permit Review - Health Food Custodian - Additional Information Required':
        'Active',
      'Post Permit Review - Health Food Custodian - Approved': 'Active',
      'Post Permit Review - Health Food Custodian - Under Review': 'Active',
      'Post Permit Review - Irrigation - Additional Information Received': 'Active',
      'Post Permit Review - Irrigation - Additional Information Required': 'Active',
      'Post Permit Review - Irrigation - Approved': 'Active',
      'Post Permit Review - Irrigation - Under Review': 'Active',
      'Post Permit Review - Landscaping - Additional Information Received': 'Active',
      'Post Permit Review - Landscaping - Additional Information Required': 'Active',
      'Post Permit Review - Landscaping - Approved': 'Active',
      'Post Permit Review - Landscaping - Under Review': 'Active',
      'Post Permit Review - Mechanical - Additional Information Received': 'Active',
      'Post Permit Review - Mechanical - Additional Information Required': 'Active',
      'Post Permit Review - Mechanical - Approved': 'Active',
      'Post Permit Review - Mechanical - Approved with Conditions': 'Active',
      'Post Permit Review - Mechanical - Under Review': 'Active',
      'Post Permit Review - Mechanical - Withdrawn': 'Cancelled',
      'Post Permit Review - NCD - Approved': 'Active',
      'Post Permit Review - NCD - Under Review': 'Active',
      'Post Permit Review - OHP - Additional Information Received': 'Active',
      'Post Permit Review - OHP - Approved': 'Active',
      'Post Permit Review - OHP - Under Review': 'Active',
      'Post Permit Review - Plumbing - Additional Information Received': 'Active',
      'Post Permit Review - Plumbing - Additional Information Required': 'Active',
      'Post Permit Review - Plumbing - Approved': 'Active',
      'Post Permit Review - Plumbing - Approved with Conditions': 'Active',
      'Post Permit Review - Plumbing - Denied': 'Cancelled',
      'Post Permit Review - Plumbing - Under Review': 'Active',
      'Post Permit Review - Plumbing - Withdrawn': 'Cancelled',
      'Post Permit Review - SAWS - Approved': 'Active',
      'Post Permit Review - SAWS - Under Review': 'Active',
      'Post Permit Review - Sidewalk/Traffic - Additional Information Received': 'Active',
      'Post Permit Review - Sidewalk/Traffic - Additional Information Required': 'Active',
      'Post Permit Review - Sidewalk/Traffic - Approved': 'Active',
      'Post Permit Review - Sidewalk/Traffic - Approved with Conditions': 'Active',
      'Post Permit Review - Sidewalk/Traffic - Under Review': 'Active',
      'Post Permit Review - Sign - Approved': 'Active',
      'Post Permit Review - Sign - Under Review': 'Active',
      'Post Permit Review - Traffic Impact Analysis - Additional Information Received':
        'Active',
      'Post Permit Review - Traffic Impact Analysis - Additional Information Required':
        'Active',
      'Post Permit Review - Traffic Impact Analysis - Approved': 'Active',
      'Post Permit Review - Traffic Impact Analysis - Approved with Conditions': 'Active',
      'Post Permit Review - Traffic Impact Analysis - Under Review': 'Active',
      'Post Permit Review - Tree Commercial - Additional Information Received': 'Active',
      'Post Permit Review - Tree Commercial - Additional Information Required': 'Active',
      'Post Permit Review - Tree Commercial - Approved': 'Active',
      'Post Permit Review - Tree Commercial - Approved with Conditions': 'Active',
      'Post Permit Review - Tree Commercial - Under Review': 'Active',
      'Post Permit Review - Zoning - Additional Information Received': 'Active',
      'Post Permit Review - Zoning - Additional Information Required': 'Active',
      'Post Permit Review - Zoning - Approved': 'Active',
      'Post Permit Review - Zoning - Approved with Conditions': 'Active',
      'Post Permit Review - Zoning - Under Review': 'Active',
      postponed: 'Cancelled',
      'Public Notification - Forwarded for Public Notification': 'In Progress',
      'Public Notification - Not Required': 'In Progress',
      'ready to issue': 'Active',
      rejected: 'Cancelled',
      'Returned to Applicant': 'Cancelled',
      'review completed': 'In Progress',
      'Revisions Required': 'In Progress',
      Revoked: 'Cancelled',
      'scheduled for hearing': 'In Progress',
      'Strategic Plan Review - Approved': 'In Progress',
      'Strategic Plan Review - Corrections Required': 'In Progress',
      'Strategic Plan Review - Forwarded for Review': 'In Progress',
      'Strategic Plan Review - Not Required': 'In Progress',
      'subdivision recorded': 'In Progress',
      'Submitted - Online': 'New',
      Suspended: 'Cancelled',
      'Technical Review - Addressing - Additional Information Received': 'In Progress',
      'Technical Review - Addressing - Additional Information Required': 'In Progress',
      'Technical Review - Addressing - Approved': 'In Progress',
      'Technical Review - Addressing - Approved with Conditions': 'In Progress',
      'Technical Review - Addressing - Denied': 'In Progress',
      'Technical Review - Addressing - Reviewed No Action': 'In Progress',
      'Technical Review - Addressing - Under Review': 'In Progress',
      'Technical Review - Addressing - Withdrawn': 'In Progress',
      'Technical Review - Aviation - Additional Information Received': 'In Progress',
      'Technical Review - Aviation - Additional Information Required': 'In Progress',
      'Technical Review - Aviation - Approved': 'In Progress',
      'Technical Review - Aviation - Approved with Conditions': 'In Progress',
      'Technical Review - Aviation - Denied': 'In Progress',
      'Technical Review - Aviation - Under Review': 'In Progress',
      'Technical Review - Aviation - Withdrawn': 'In Progress',
      'Technical Review - Commercial Building - Additional Information Received':
        'In Progress',
      'Technical Review - Commercial Building - Additional Information Required':
        'In Progress',
      'Technical Review - Commercial Building - Approved': 'In Progress',
      'Technical Review - Commercial Building - Approved with Conditions': 'In Progress',
      'Technical Review - Commercial Building - Denied': 'In Progress',
      'Technical Review - Commercial Building - Reviewed No Action': 'In Progress',
      'Technical Review - Commercial Building - Under Review': 'In Progress',
      'Technical Review - Commercial Building - Withdrawn': 'In Progress',
      'Technical Review - Disability - Approved': 'In Progress',
      'Technical Review - Disability - Reviewed No Action': 'In Progress',
      'Technical Review - Disability - Under Review': 'In Progress',
      'Technical Review - Drainage - Additional Information Received': 'In Progress',
      'Technical Review - Drainage - Additional Information Required': 'In Progress',
      'Technical Review - Drainage - Approved': 'In Progress',
      'Technical Review - Drainage - Denied': 'In Progress',
      'Technical Review - Drainage - Under Review': 'In Progress',
      'Technical Review - Drainage - Withdrawn': 'In Progress',
      'Technical Review - Electric - Additional Information Received': 'In Progress',
      'Technical Review - Electric - Additional Information Required': 'In Progress',
      'Technical Review - Electric - Approved': 'In Progress',
      'Technical Review - Electric - Approved with Conditions': 'In Progress',
      'Technical Review - Electric - Denied': 'In Progress',
      'Technical Review - Electric - Reviewed No Action': 'In Progress',
      'Technical Review - Electric - Under Review': 'In Progress',
      'Technical Review - Electric - Withdrawn': 'In Progress',
      'Technical Review - Energy - Additional Information Received': 'In Progress',
      'Technical Review - Energy - Additional Information Required': 'In Progress',
      'Technical Review - Energy - Approved': 'In Progress',
      'Technical Review - Energy - Approved with Conditions': 'In Progress',
      'Technical Review - Energy - Reviewed No Action': 'In Progress',
      'Technical Review - Energy - Under Review': 'In Progress',
      'Technical Review - Energy - Withdrawn': 'In Progress',
      'Technical Review - Fire - Additional Information Received': 'In Progress',
      'Technical Review - Fire - Additional Information Required': 'In Progress',
      'Technical Review - Fire - Approved': 'In Progress',
      'Technical Review - Fire - Approved with Conditions': 'In Progress',
      'Technical Review - Fire - Denied': 'In Progress',
      'Technical Review - Fire - Reviewed No Action': 'In Progress',
      'Technical Review - Fire - Under Review': 'In Progress',
      'Technical Review - Fire - Withdrawn': 'In Progress',
      'Technical Review - Fire OCL - Additional Information Received': 'In Progress',
      'Technical Review - Fire OCL - Additional Information Required': 'In Progress',
      'Technical Review - Fire OCL - Approved': 'In Progress',
      'Technical Review - Fire OCL - Approved with Conditions': 'In Progress',
      'Technical Review - Fire OCL - Denied': 'In Progress',
      'Technical Review - Fire OCL - Reviewed No Action': 'In Progress',
      'Technical Review - Fire OCL - Under Review': 'In Progress',
      'Technical Review - Fire OCL - Withdrawn': 'In Progress',
      'Technical Review - Fire Smoke Control - Additional Information Received':
        'In Progress',
      'Technical Review - Fire Smoke Control - Additional Information Required':
        'In Progress',
      'Technical Review - Fire Smoke Control - Approved': 'In Progress',
      'Technical Review - Fire Smoke Control - Reviewed No Action': 'In Progress',
      'Technical Review - Fire Smoke Control - Under Review': 'In Progress',
      'Technical Review - Fire Smoke Control - Withdrawn': 'In Progress',
      'Technical Review - Flood - Additional Information Received': 'In Progress',
      'Technical Review - Flood - Additional Information Required': 'In Progress',
      'Technical Review - Flood - Approved': 'In Progress',
      'Technical Review - Flood - Denied': 'In Progress',
      'Technical Review - Flood - Reviewed No Action': 'In Progress',
      'Technical Review - Flood - Under Review': 'In Progress',
      'Technical Review - Flood - Withdrawn': 'In Progress',
      'Technical Review - Health Environmental - Additional Information Received':
        'In Progress',
      'Technical Review - Health Environmental - Additional Information Required':
        'In Progress',
      'Technical Review - Health Environmental - Approved': 'In Progress',
      'Technical Review - Health Environmental - Approved with Conditions': 'In Progress',
      'Technical Review - Health Environmental - Denied': 'In Progress',
      'Technical Review - Health Environmental - Reviewed No Action': 'In Progress',
      'Technical Review - Health Environmental - Under Review': 'In Progress',
      'Technical Review - Health Environmental - Withdrawn': 'In Progress',
      'Technical Review - Health Food Custodian - Additional Information Received':
        'In Progress',
      'Technical Review - Health Food Custodian - Additional Information Required':
        'In Progress',
      'Technical Review - Health Food Custodian - Approved': 'In Progress',
      'Technical Review - Health Food Custodian - Approved with Conditions':
        'In Progress',
      'Technical Review - Health Food Custodian - Reviewed No Action': 'In Progress',
      'Technical Review - Health Food Custodian - Under Review': 'In Progress',
      'Technical Review - Health Food Custodian - Withdrawn': 'In Progress',
      'Technical Review - Irrigation - Additional Information Received': 'In Progress',
      'Technical Review - Irrigation - Additional Information Required': 'In Progress',
      'Technical Review - Irrigation - Approved': 'In Progress',
      'Technical Review - Irrigation - Approved with Conditions': 'In Progress',
      'Technical Review - Irrigation - Denied': 'In Progress',
      'Technical Review - Irrigation - Reviewed No Action': 'In Progress',
      'Technical Review - Irrigation - Under Review': 'In Progress',
      'Technical Review - Irrigation - Withdrawn': 'In Progress',
      'Technical Review - Landscaping - Additional Information Received': 'In Progress',
      'Technical Review - Landscaping - Additional Information Required': 'In Progress',
      'Technical Review - Landscaping - Approved': 'In Progress',
      'Technical Review - Landscaping - Approved with Conditions': 'In Progress',
      'Technical Review - Landscaping - Denied': 'In Progress',
      'Technical Review - Landscaping - Reviewed No Action': 'In Progress',
      'Technical Review - Landscaping - Under Review': 'In Progress',
      'Technical Review - Landscaping - Withdrawn': 'In Progress',
      'Technical Review - Mechanical - Additional Information Received': 'In Progress',
      'Technical Review - Mechanical - Additional Information Required': 'In Progress',
      'Technical Review - Mechanical - Approved': 'In Progress',
      'Technical Review - Mechanical - Approved with Conditions': 'In Progress',
      'Technical Review - Mechanical - Denied': 'In Progress',
      'Technical Review - Mechanical - Reviewed No Action': 'In Progress',
      'Technical Review - Mechanical - Under Review': 'In Progress',
      'Technical Review - Mechanical - Withdrawn': 'In Progress',
      'Technical Review - NCD - Additional Information Received': 'In Progress',
      'Technical Review - NCD - Additional Information Required': 'In Progress',
      'Technical Review - NCD - Approved': 'In Progress',
      'Technical Review - NCD - Approved with Conditions': 'In Progress',
      'Technical Review - NCD - Denied': 'In Progress',
      'Technical Review - NCD - Reviewed No Action': 'In Progress',
      'Technical Review - NCD - Under Review': 'In Progress',
      'Technical Review - NCD - Withdrawn': 'In Progress',
      'Technical Review - OHP - Additional Information Received': 'In Progress',
      'Technical Review - OHP - Additional Information Required': 'In Progress',
      'Technical Review - OHP - Approved': 'In Progress',
      'Technical Review - OHP - Approved with Conditions': 'In Progress',
      'Technical Review - OHP - Denied': 'In Progress',
      'Technical Review - OHP - Reviewed No Action': 'In Progress',
      'Technical Review - OHP - Under Review': 'In Progress',
      'Technical Review - OHP - Withdrawn': 'In Progress',
      'Technical Review - Plumbing - Additional Information Received': 'In Progress',
      'Technical Review - Plumbing - Additional Information Required': 'In Progress',
      'Technical Review - Plumbing - Approved': 'In Progress',
      'Technical Review - Plumbing - Approved with Conditions': 'In Progress',
      'Technical Review - Plumbing - Denied': 'In Progress',
      'Technical Review - Plumbing - Reviewed No Action': 'In Progress',
      'Technical Review - Plumbing - Under Review': 'In Progress',
      'Technical Review - Plumbing - Withdrawn': 'In Progress',
      'Technical Review - Rights Determination - Active': 'In Progress',
      'Technical Review - Rights Determination - Additional Information Received':
        'In Progress',
      'Technical Review - Rights Determination - Additional Information Required':
        'In Progress',
      'Technical Review - Rights Determination - Denied': 'In Progress',
      'Technical Review - Rights Determination - Expired': 'In Progress',
      'Technical Review - Rights Determination - Invalid': 'In Progress',
      'Technical Review - Rights Determination - Under Review': 'In Progress',
      'Technical Review - Rights Determination - Withdrawn': 'In Progress',
      'Technical Review - SAWS - Additional Information Received': 'In Progress',
      'Technical Review - SAWS - Additional Information Required': 'In Progress',
      'Technical Review - SAWS - Approved': 'In Progress',
      'Technical Review - SAWS - Denied': 'In Progress',
      'Technical Review - SAWS - Under Review': 'In Progress',
      'Technical Review - SAWS - Withdrawn': 'In Progress',
      'Technical Review - Sidewalk/Traffic - Additional Information Received':
        'In Progress',
      'Technical Review - Sidewalk/Traffic - Additional Information Required':
        'In Progress',
      'Technical Review - Sidewalk/Traffic - Approved': 'In Progress',
      'Technical Review - Sidewalk/Traffic - Approved with Conditions': 'In Progress',
      'Technical Review - Sidewalk/Traffic - Denied': 'In Progress',
      'Technical Review - Sidewalk/Traffic - Reviewed No Action': 'In Progress',
      'Technical Review - Sidewalk/Traffic - Under Review': 'In Progress',
      'Technical Review - Sidewalk/Traffic - Withdrawn': 'In Progress',
      'Technical Review - Sign - Additional Information Received': 'In Progress',
      'Technical Review - Sign - Additional Information Required': 'In Progress',
      'Technical Review - Sign - Approved': 'In Progress',
      'Technical Review - Sign - Approved with Conditions': 'In Progress',
      'Technical Review - Sign - Denied': 'In Progress',
      'Technical Review - Sign - Reviewed No Action': 'In Progress',
      'Technical Review - Sign - Under Review': 'In Progress',
      'Technical Review - Street Lights - Additional Information Received': 'In Progress',
      'Technical Review - Street Lights - Additional Information Required': 'In Progress',
      'Technical Review - Street Lights - Approved': 'In Progress',
      'Technical Review - Street Lights - Approved with Conditions': 'In Progress',
      'Technical Review - Street Lights - Reviewed No Action': 'In Progress',
      'Technical Review - Street Lights - Under Review': 'In Progress',
      'Technical Review - Street Lights - Withdrawn': 'In Progress',
      'Technical Review - Traffic Impact Analysis - Additional Information Received':
        'In Progress',
      'Technical Review - Traffic Impact Analysis - Additional Information Required':
        'In Progress',
      'Technical Review - Traffic Impact Analysis - Approved': 'In Progress',
      'Technical Review - Traffic Impact Analysis - Approved with Conditions':
        'In Progress',
      'Technical Review - Traffic Impact Analysis - Denied': 'In Progress',
      'Technical Review - Traffic Impact Analysis - Reviewed No Action': 'In Progress',
      'Technical Review - Traffic Impact Analysis - Under Review': 'In Progress',
      'Technical Review - Traffic Impact Analysis - Withdrawn': 'In Progress',
      'Technical Review - Tree Commercial - Additional Information Received':
        'In Progress',
      'Technical Review - Tree Commercial - Additional Information Required':
        'In Progress',
      'Technical Review - Tree Commercial - Approved': 'In Progress',
      'Technical Review - Tree Commercial - Approved with Conditions': 'In Progress',
      'Technical Review - Tree Commercial - Preliminary Tree Inspection': 'In Progress',
      'Technical Review - Tree Commercial - Reviewed No Action': 'In Progress',
      'Technical Review - Tree Commercial - Rights Determination Review': 'In Progress',
      'Technical Review - Tree Commercial - Under Review': 'In Progress',
      'Technical Review - Tree Commercial - Withdrawn': 'In Progress',
      'Technical Review - Zoning - Additional Information Received': 'In Progress',
      'Technical Review - Zoning - Additional Information Required': 'In Progress',
      'Technical Review - Zoning - Approved': 'In Progress',
      'Technical Review - Zoning - Approved with Conditions': 'In Progress',
      'Technical Review - Zoning - Denied': 'In Progress',
      'Technical Review - Zoning - Reviewed No Action': 'In Progress',
      'Technical Review - Zoning - Under Review': 'In Progress',
      'Technical Review - Zoning - Withdrawn': 'In Progress',
      'tolling - hearing pending': 'In Progress',
      'TPW Storm Water Review - Approved': 'In Progress',
      'TPW Storm Water Review - Corrections Required': 'In Progress',
      'TPW Storm Water Review - Not Required': 'In Progress',
      'Transportation Impact Review - Not Required': 'In Progress',
      'update intake pending': 'In Progress',
      'update intake pending - fees due': 'In Progress',
      'Urban Forestry Review - Approved': 'In Progress',
      'Urban Forestry Review - Approved-Part 1 Existing Only': 'In Progress',
      'Urban Forestry Review - Approved-Partial': 'In Progress',
      'Urban Forestry Review - CIP': 'In Progress',
      'Urban Forestry Review - Corrections Required': 'In Progress',
      'Urban Forestry Review - Not Required': 'In Progress',
      void: 'Cancelled',
      'waiting on fiscal': 'In Progress',
      'waiting on legal': 'In Progress',
      'Waiting on Ordinance': 'In Progress',
      'Water Backflow Review - Approved': 'In Progress',
      'Water Development Review - Approved': 'In Progress',
      'Water Development Review - Corrections Required': 'In Progress',
      'Water Development Storm Water Review - Approved': 'In Progress',
      'Water Grease Trap Review - Approved': 'In Progress',
      withdrawn: 'Cancelled',
      'Zoning Review - Approved': 'In Progress',
      'Zoning Review - Corrections Required': 'In Progress',
      'Zoning Review - Not Required': 'In Progress',
      'Zoning Review - Rezoning Not Required': 'In Progress',
      'Zoning Review - Rezoning Required': 'In Progress',
    },
    'tenancy-change': {
      approved: 'Completed',
      cancelled: 'Cancelled',
      New: 'New',
    },
  },
  [State.FL]: {
    'building-permit': {
      ACTIV: 'Active',
      active: 'Active',
      'Active (In Review)': 'Active',
      'Active (Return for Corrections)': 'Active',
      'AGENCY NOT APPROVE': 'In Progress',
      'AGENCY REVIE': 'In Progress',
      'Agency Review': 'In Progress',
      'Applicant Corrections': 'In Progress',
      'Application Completion Check - Completed': 'In Progress',
      'Application Completion Check - Submittal Received': 'New',
      'Application Intake - Awaiting Plans': 'New',
      'Application Intake - Deemed Complete': 'In Progress',
      'Application Intake - File Validation Issues': 'In Progress',
      'Application Intake - Missing Information': 'In Progress',
      'Application Intake - New': 'New',
      'Application Intake - None': 'In Progress',
      'Application Intake - Plans Received': 'New',
      'Application Intake - Previously Active': 'In Progress',
      'Application Review - Accepted': 'Active',
      'Application Review - Awaiting Client Reply': 'In Progress',
      'Application Review - Awaiting Plans': 'In Progress',
      'Application Review - File Validation Issues': 'In Progress',
      'Application Review - Payment Received': 'In Progress',
      'Application Review - Plans Submitted': 'In Progress',
      'Application Review - Withdrawn': 'In Progress',
      applied: 'New',
      approved: 'Active',
      'Building Review - Approved': 'Completed',
      'Building Review - complete': 'Completed',
      cancelled: 'Cancelled',
      closed: 'Completed',
      'Closure - Withdrawn': 'Cancelled',
      Completed: 'Completed',
      denied: 'Cancelled',
      'Denied due to expiration rules': 'Cancelled',
      'Document Review-Owner Builder Acknowledgement-1 - Awaiting Client Reply':
        'In Progress',
      'Document Review-Owner Builder Acknowledgement-1 - Document Uploaded':
        'In Progress',
      'Document Review-Owner Builder Acknowledgement-1 - Not Accepted': 'In Progress',
      'Document Review-Private Provider Package-1 - Awaiting Client Reply': 'In Progress',
      'Document Review-Private Provider Package-1 - Document Uploaded': 'In Progress',
      'DSD Revie': 'In Progress',
      'DSD Review': 'In Progress',
      Expired: 'Cancelled',
      'Expired due to expiration rules': 'Cancelled',
      'Expired-Replaced': 'Cancelled',
      final: 'Completed',
      Finaled: 'Completed',
      Finalized: 'Completed',
      'Finalized-NIF': 'Completed',
      'Fire Review - Approved': 'In Progress',
      'Fire Review - complete': 'In Progress',
      'Fire Review - Not Applicable': 'In Progress',
      'Fire Review - Revisions Required': 'In Progress',
      'Flood Review - Approved': 'In Progress',
      Hardhold: 'Hold',
      'Historic Application Review - Approved': 'In Progress',
      'Historic Application Review - Awaiting Client Reply': 'In Progress',
      'Historic Application Review - No AR&HP Review Required': 'In Progress',
      'Historic Application Review - Plans Submitted': 'In Progress',
      Hold: 'Hold',
      'IN REVIE': 'In Progress',
      'In Review': 'In Progress',
      INTAK: 'New',
      Intake: 'New',
      'Issuance - Issued': 'Active',
      issued: 'Active',
      'Issued - Reapplied': 'Active',
      'Natural Resources Review -  Not Applicable': 'In Progress',
      'Not Submitted': 'New',
      open: 'Active',
      'PENDING PAYMEN': 'In Progress',
      'pending payment': 'In Progress',
      'PENDING REVIEW PAYMEN': 'In Progress',
      'Pending Review Payment': 'In Progress',
      'Permit Issuance - Issued': 'Active',
      'permit issued': 'Active',
      'Permit status updated to Denied due to expiration rules.': 'Cancelled',
      'Permit status updated to Expired due to expiration rules.': 'Cancelled',
      'Permit Submitted': 'New',
      'Plans Coordination - Approved': 'In Progress',
      'Plans Coordination - Corrections Required': 'In Progress',
      'Plans Coordination - Review Complete': 'In Progress',
      'Plans Distribution -  Awaiting Client Reply': 'In Progress',
      'Plans Distribution -  Payment Received': 'In Progress',
      'Plans Distribution -  Routed for Electronic Review': 'In Progress',
      'Plans Distribution - complete': 'In Progress',
      'Plans Distribution - Routed for Review': 'In Progress',
      Processed: 'In Progress',
      'RETURN FOR CORRECTION': 'In Progress',
      'Return for Corrections': 'In Progress',
      'Reviews - Commercial New Construction - Completed': 'Active',
      'Reviews - Commercial New Construction - Submittal Received': 'In Progress',
      'Revision of Issued Permit': 'Active',
      Revoked: 'Cancelled',
      'Site Review -  Not Applicable': 'In Progress',
      'stop work': 'Hold',
      'Submitted - Online': 'New',
      'Sufficiency Review': 'In Progress',
      SUSPENDE: 'Cancelled',
      TEMPORAR: 'Active',
      'Urban Design Review - Not Applicable': 'In Progress',
      void: 'Cancelled',
      Voided: 'Cancelled',
      'Water Demolition Review - Approved': 'In Progress',
      'Water Demolition Review - Plans Submitted': 'In Progress',
      withdrawn: 'Cancelled',
      'Zoning Review - Approved': 'In Progress',
      'Zoning Review Failed': 'Cancelled',
    },
    rezoning: {
      active: 'Active',
      'Admin Support Review - Complete': 'In Progress',
      'Admin Support Review - DRC Meeting Prep': 'In Progress',
      'Admin Support Review - Map Review': 'In Progress',
      'Application Intake - New': 'New',
      'Application Review - Accepted': 'New',
      'Application Review - Awaiting Client Reply': 'In Progress',
      'Application Review - Pending': 'In Progress',
      applied: 'New',
      approved: 'Completed',
      cancelled: 'Cancelled',
      'Case Noticing - Complete': 'In Progress',
      'CITY COUNCIL MEETING SCHEDULED': 'In Progress',
      closed: 'Completed',
      'Closure - Withdrawn': 'Cancelled',
      Completed: 'Completed',
      'Completeness Review - Deemed Complete': 'In Progress',
      'Completeness Review - Revisions Required': 'In Progress',
      'Completeness Review - Rezone - Completed': 'Active',
      denied: 'Cancelled',
      'Distribute HEX Order - Completed': 'In Progress',
      'DRC Meeting - Complete': 'In Progress',
      'DRC Meeting - Continued': 'In Progress',
      Expired: 'Cancelled',
      'Finalize Date for Public Hearing - Completed': 'In Progress',
      'Fire Review - Consistent with Conditions': 'In Progress',
      'Fire Review - No Comment': 'In Progress',
      Hardhold: 'Hold',
      'hearing scheduled': 'In Progress',
      'Historic Preservation Review - Consistent': 'In Progress',
      Hold: 'Hold',
      'Hold HEX Hearing - Completed': 'In Progress',
      'In Review': 'In Progress',
      'Inspection Complete': 'In Progress',
      Intake: 'New',
      issued: 'Completed',
      'LDC ROW Review - Consistent': 'In Progress',
      'LPA Packet Prep and Distribution - Completed': 'In Progress',
      'LPA Public Hearing - Recommend Approval': 'In Progress',
      'Methodology Review - Approved': 'In Progress',
      'Mitigation Tracking - NA': 'In Progress',
      'Natural Resources Review - Consistent with Conditions': 'In Progress',
      'Natural Resources Review - Inconsistent w Tech Std/Code': 'In Progress',
      'Notice of Filing of Application - undefined - Complete': 'In Progress',
      'Notice of Filing of Application - undefined - Pending': 'In Progress',
      'Notice of Filing of Application - Updated via EMSE - Awaiting Client Reply':
        'In Progress',
      open: 'In Progress',
      'P&Z MEETING SCHEDULED': 'In Progress',
      'Planning Director Review - Complete': 'In Progress',
      'Plans Distribution -  Routed for Electronic Review': 'In Progress',
      'Staff Report and Recommendation - Recommend Approval': 'In Progress',
      'Stormwater Review - Consistent': 'In Progress',
      Submitted: 'New',
      'Submitted - Online': 'New',
      'Sufficiency Review - Completed': 'In Progress',
      'Sufficiency Review - Submittal Received': 'In Progress',
      'Traffic Analysis - Approved': 'In Progress',
      'Traffic Analysis - Completed': 'In Progress',
      'Traffic Analysis - NA': 'In Progress',
      'Traffic Study Review - Approved': 'In Progress',
      'Transportation Review - Consistent': 'In Progress',
      'Transportation Review - Inconsistent w Tech Std/Code': 'In Progress',
      'Transportation Review - Inconsistent with Code': 'In Progress',
      'Transportation Review - Pending': 'In Progress',
      'Urban Design Review - Inconsistent w Tech Std/Code': 'In Progress',
      void: 'Cancelled',
      'Waiting for Applicant': 'In Progress',
      'Wastewater Review - Consistent': 'In Progress',
      'Wastewater Review - Consistent with Conditions': 'In Progress',
      'Water Review - Consistent': 'In Progress',
      'Water Review - Consistent with Conditions': 'In Progress',
      withdrawn: 'Cancelled',
      'Zoning Manager Review - Complete': 'In Progress',
    },
    'site-plan': {
      ACTIV: 'Active',
      active: 'Active',
      'Active (In Review)': 'Active',
      'Active (Return for Corrections)': 'Active',
      'AGENCY REVIE': 'In Progress',
      'Application Intake - Awaiting Plans': 'In Progress',
      'Application Intake - New': 'New',
      'Application Intake - Plans Received': 'New',
      'Application Intake - Withdrawn': 'Cancelled',
      'Application Review - SDP & SCP - Completed': 'In Progress',
      'Application Review - SDP & SCP - Submittal Received': 'In Progress',
      'Application Review - SDPL - Completed': 'In Progress',
      'Application Review - SDPL - Submittal Received': 'In Progress',
      applied: 'New',
      approved: 'Completed',
      cancelled: 'Cancelled',
      closed: 'Completed',
      'Closure - Complete': 'Completed',
      'Closure - Withdrawn': 'Cancelled',
      Completed: 'Completed',
      'CUSTOMER RESPONDED': 'In Progress',
      denied: 'Cancelled',
      'Document Review-Cancellation Letter-1 -  Document Uploaded': 'In Progress',
      'Document Review-Cancellation Letter-1 - Awaiting Client Reply': 'In Progress',
      'Document Review-Cancellation Letter-1 - Complete': 'In Progress',
      'Document Review-Cancellation Letter-1 - Resubmitted': 'In Progress',
      Expired: 'Cancelled',
      'Expired due to expiration rules': 'Cancelled',
      Finalized: 'Completed',
      'Finalized-NIF': 'Completed',
      'Fire Review - Approved': 'In Progress',
      'hearing scheduled': 'In Progress',
      'Historic Application Review - Approved': 'In Progress',
      'Historic Application Review - Awaiting Client Reply': 'In Progress',
      'Historic Application Review - Plans Submitted': 'In Progress',
      Hold: 'Hold',
      'IN REVIE': 'In Progress',
      'In Review': 'In Progress',
      INTAK: 'New',
      Intake: 'New',
      issued: 'Completed',
      'Natural Resources Review -  Approved': 'In Progress',
      'Natural Resources Review -  Approved with Comments': 'In Progress',
      'Natural Resources Review -  Disapproved - Corrections Req': 'In Progress',
      'Natural Resources Review -  Not Applicable': 'In Progress',
      'Natural Resources Review - Complete': 'In Progress',
      'Not Submitted': 'New',
      open: 'Active',
      'PENDING PAYMEN': 'In Progress',
      'pending payment': 'In Progress',
      'Permit Review - SDPL - Submittal Received': 'In Progress',
      'Permit status updated to Expired due to expiration rules.': 'Cancelled',
      'Permit voided due to expiration rules.': 'Cancelled',
      'Plans Coordination - Approved': 'In Progress',
      'Plans Coordination - Corrections Required': 'In Progress',
      'Plans Coordination - Previously Active': 'In Progress',
      'Plans Distribution -  Awaiting Client Reply': 'In Progress',
      'Plans Distribution -  Payment Received': 'In Progress',
      'Plans Distribution -  Resubmitted': 'In Progress',
      'Plans Distribution -  Routed for Electronic Review': 'In Progress',
      'Plans Distribution -  TBD': 'In Progress',
      'Plans Distribution - Active': 'In Progress',
      'RETURN FOR CORRECTION': 'In Progress',
      'Return for Corrections': 'In Progress',
      Revoked: 'Cancelled',
      'Site Application Review -  Accepted': 'In Progress',
      'Site Application Review -  Awaiting Client Reply': 'In Progress',
      'Site Application Review -  File Validation Issues': 'In Progress',
      'Site Application Review -  Plans Submitted': 'In Progress',
      'Site Application Review -  Withdrawn': 'Cancelled',
      'Site Application Review - Complete': 'Active',
      'Site Review -  Approved': 'Active',
      'Site Review -  Disapproved - Corrections Req': 'In Progress',
      'Site Review -  Not Applicable': 'Active',
      'Site Review - Complete': 'Active',
      'Site Review - Pending': 'In Progress',
      Submitted: 'New',
      'Submitted - Online': 'New',
      TEMPORAR: 'Active',
      'Urban Design Review -  Disapproved - Corrections Req': 'In Progress',
      'Urban Design Review - Approved': 'In Progress',
      'Urban Design Review - Approved with Comments': 'In Progress',
      VOI: 'Cancelled',
      void: 'Cancelled',
      withdrawn: 'Cancelled',
      'Zoning Review -  Disapproved - Corrections Req': 'In Progress',
      'Zoning Review - Approved': 'Active',
      'Zoning Review - Complete': 'Active',
      'Zoning Review - Not Applicable': 'In Progress',
    },
  },
};
